export const formDataExample = {
  id: 'WE08jXCQ',
  type: 'form',
  url_code: 'WE08jXCQ',
  properties: {
    is_public: true,
    is_active: true,
    title: 'My amazing form',
    description: 'Description',
  },
  design: {
    fontSize: 12,
    backgroundColor: 'red',
  },
  logic: {},
  data: {},
  validation: {},
  pages: [
    {
      id: 'WE08jXCQ55',
      type: 'page',
      position: 0,
      properties: {
        name: 'page1',
        description: 'Description',
      },
      design: {
        fontSize: 12,
        backgroundColor: 'red',
      },
      logic: {},
      data: {},
      elements: [
        {
          type: 'element',
          id: 'WE0sldkCQ55',
          position: 0,
          childs: {
            label: {
              type: 'label',
              id: 'WsdossppmdCQ55',
              properties: {
                label: 'Super label',
              },
              design: {
                fontSize: 12,
                backgroundColor: 'red',
              },
            },
            description: {
              type: 'description',
              id: 'sd8s9d5d2c',
              properties: {
                description: 'Super Description',
              },
              design: {
                fontSize: 12,
                backgroundColor: 'red',
              },
            },
            input: {
              type: 'input',
              id: 's8d49e5d3f2c',
              properties: {
                field_type: 'select',
                is_public: true,
                is_active: true,
                title: 'My amazing form',
                description: 'Description',
                isRequired: true,
                choices: [
                  {
                    position: 0,
                    id: 'EMj5YYMUeEor',
                    label: 'option 1',
                  },
                  {
                    position: 1,
                    id: 'EMj5YYMUeEor',
                    label: 'option 2',
                  },
                ],
              },
              design: {
                fontSize: 12,
                backgroundColor: 'red',
              },
            },
          },
          properties: {
            is_public: true,
            is_active: true,
            title: 'My amazing form',
            description: 'Description',
            isRequired: true,
          },
          design: {
            fontSize: 12,
            backgroundColor: 'red',
          },
          logic: {},
          data: {},
          validation: {},
        },
      ],
    },
    {
      id: 'dfdsf5sdfsfs',
      type: 'page',
      position: 1,
      properties: {
        name: 'page2',
        description: 'Description',
      },
      design: {
        fontSize: 15,
        backgroundColor: 'blue',
      },
      logic: {},
      data: {},
      elements: [
        {
          type: 'element',
          id: 's8ds85f1dds',
          position: 0,
          childs: {
            label: {
              type: 'label',
              id: 'q8dd11svds',
              properties: {
                label: 'Super label',
              },
              design: {
                fontSize: 12,
                backgroundColor: 'red',
              },
            },
            description: {
              type: 'description',
              id: '89d522x1sed',
              properties: {
                description: 'Super Description',
              },
              design: {
                fontSize: 12,
                backgroundColor: 'red',
              },
            },
            input: {
              type: 'input',
              id: 'a8s522w3w36654d',
              properties: {
                field_type: 'select',
                is_public: true,
                is_active: true,
                title: 'My amazing form',
                description: 'Description',
                isRequired: true,
                choices: [
                  {
                    position: 0,
                    id: 'q8d5d222ccccd',
                    label: 'option 1',
                  },
                  {
                    position: 1,
                    id: 'EMq8ds55ddsed',
                    label: 'option 2',
                  },
                ],
              },
              design: {
                fontSize: 12,
                backgroundColor: 'red',
              },
            },
          },
          properties: {
            is_public: true,
            is_active: true,
            title: 'My amazing form',
            description: 'Description',
            isRequired: true,
          },
          design: {
            fontSize: 12,
            backgroundColor: 'red',
          },
          logic: {},
          data: {},
          validation: {},
        },
      ],
    },
  ],
}
